import { render, staticRenderFns } from "./BannerSettingPage.vue?vue&type=template&id=4d4de5ea&scoped=true"
import script from "./BannerSettingPage.vue?vue&type=script&lang=js"
export * from "./BannerSettingPage.vue?vue&type=script&lang=js"
import style0 from "./BannerSettingPage.vue?vue&type=style&index=0&id=4d4de5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4de5ea",
  null
  
)

export default component.exports